import { Col, Row } from 'antd';
import CustomCard from '../../../../components/Antd/Card';
import CustomStatistic from '../../../../components/Antd/Statistic';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { Language } from './constants/language.constant';

export default function ProductReport(props) {
	const { data } = props;

	return (
		<>
			<Row gutter={20} justify="center" style={{ padding: '20px' }}>
				<Col span={5}>
					<CustomCard bordered={false}>
						<CustomStatistic
							title={Language[Enviroment.LANGUAGE]?.total_products}
							value={data.total_products}
							valueStyle={{
								color: '#1890ff',
							}}
						/>
					</CustomCard>
				</Col>
				<Col span={5}>
					<CustomCard bordered={false}>
						<CustomStatistic
							title={Language[Enviroment.LANGUAGE]?.products_without_price}
							value={data.products_price_zero}
							valueStyle={{
								color: '#1890ff',
							}}
						/>
					</CustomCard>
				</Col>
				<Col span={5}>
					<CustomCard bordered={false}>
						<CustomStatistic
							title={Language[Enviroment.LANGUAGE]?.products_without_stock}
							value={data.products_stock_zero}
							valueStyle={{
								color: '#1890ff',
							}}
						/>
					</CustomCard>
				</Col>

				<Col span={5}>
					<CustomCard bordered={false}>
						<CustomStatistic
							title={Language[Enviroment.LANGUAGE]?.products_without_promotions}
							value={data.products_promotions_null}
							valueStyle={{
								color: '#1890ff',
							}}
						/>
					</CustomCard>
				</Col>
			</Row>
			<Row gutter={20} justify="center" style={{ padding: '20px' }}>
				<Col span={5}>
					<CustomCard bordered={false}>
						<CustomStatistic
							title={Language[Enviroment.LANGUAGE]?.total_general_products}
							value={data.products_total_percentage}
							suffix="%"
							valueStyle={{
								color: '#1890ff',
							}}
						/>
					</CustomCard>
				</Col>
				<Col span={5}>
					<CustomCard bordered={false}>
						<CustomStatistic
							title={Language[Enviroment.LANGUAGE]?.products_without_price}
							value={data.products_price_zero_percentage}
							suffix="%"
							valueStyle={{
								color: '#1890ff',
							}}
						/>
					</CustomCard>
				</Col>
				<Col span={5}>
					<CustomCard bordered={false}>
						<CustomStatistic
							title={Language[Enviroment.LANGUAGE]?.products_without_stock}
							value={data.products_stock_zero_percentage}
							suffix="%"
							valueStyle={{
								color: '#1890ff',
							}}
						/>
					</CustomCard>
				</Col>
				<Col span={5}>
					<CustomCard bordered={false}>
						<CustomStatistic
							title={Language[Enviroment.LANGUAGE]?.products_without_promotions}
							value={data.products_promotions_null_percentage}
							suffix="%"
							valueStyle={{
								color: '#1890ff',
							}}
						/>
					</CustomCard>
				</Col>
			</Row>
		</>
	);
}
